import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import cleanCSSIdentifier from "@jmc/utils/utils/clean-css-identifier";
import React, { ReactNode } from "react";

import classnames from "classnames";
import style from "./style.module.scss";

interface Props {
    id?: string;
    backgroundColor?: "primary" | "gray" | "white";
    children?: ReactNode;
    contentAlignment?: "start" | "end";
    footer?: JSX.Element | JSX.Element[];
    noPaddingXl?: boolean;
    image?: JSX.Element;
    title?: string;
    removePaddingTopImage?: boolean;
}

export const Callout = (props: Props): JSX.Element => {
    const {
        id = "",
        backgroundColor,
        children,
        contentAlignment,
        footer,
        image,
        noPaddingXl = false,
        title,
        removePaddingTopImage = false,
    } = props;
    const primary = backgroundColor ? backgroundColor === "primary" : true;

    return (
        <div
            className={classnames(
                style.element,
                backgroundColor === "white" ? style.white : backgroundColor === "gray" ? style.gray : style.primary,
                contentAlignment === "start" ? (image ? style.mediaStart : style.contentStart) : null,
                contentAlignment === "end" ? (image ? style.mediaEnd : style.contentEnd) : null,
            )}
            data-test-id={`Hero.${id}`}
            id={`Hero.${cleanCSSIdentifier(id?.toLowerCase())}`}
        >
            <div className={classnames(style.wrapper, noPaddingXl ? style.noPaddingXl : null)}>
                {image && (
                    <div
                        className={classnames(
                            style.imageContainer,
                            removePaddingTopImage && style.removePaddingTopImage,
                        )}
                    >
                        {image}
                    </div>
                )}
                <div className={style.container}>
                    <div className={style.contentWrapper}>
                        <div className={style.title} data-test-id={"Hero.Title"}>
                            <Typography color={primary ? "white" : "dark"} component="h2" variant="h2" weight="400">
                                {title}
                            </Typography>
                        </div>
                        <div className={style.content}>
                            <div className={style.body}>
                                <Typography color={primary ? "white" : "light"} variant="body-02">
                                    {children}
                                </Typography>
                            </div>
                            {(Array.isArray(footer) ? footer.length > 0 : !!footer) && (
                                <div className={style.footer} data-test-id={"Hero.Footer"}>
                                    {footer}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
